<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-select
          label="Perfil"
          :items="profileSelectorItems"
          v-model="profileSelected"
          item-text="text"
          item-value="value"
        ></v-select>
        <v-card
          elevation="0"
        >
          <v-flex>
            <v-btn color="secondary" large depressed :loading="loading" @click.prevent="loadSummary">
              <v-icon>refresh</v-icon>
              Regenerar
            </v-btn>
          </v-flex>
          <v-flex>
            <template v-if="loading">
              <skeleton-loader
                v-for="sl in [0, 1, 2, 3]"
                :key="sl"
                class="my-0 mx-2 pa-0"
                :width="'100%'"
                :height="40"
                style="margin-bottom: 4px !important"
                animation="fade"
              />
            </template>
            <template v-else>
              <v-card
                elevation="0"
              >
                <v-subheader>
                  <v-icon>tips_and_updates</v-icon>
                  Resumen para Redes Sociales
                </v-subheader>
                <v-card-text class="font-weight-bold" style="text-align: left;">
                  {{ summary }}
                </v-card-text>
                <v-card-actions>
                  <v-list-tile class="grow">
                    <v-btn @click.prevent="copySummaryInClipboard()" flat small>
                      <v-icon class="mr-1" @click.prevent="copySummaryInClipboard()">content_copy</v-icon>
                      Copiar Texto
                    </v-btn>
                  </v-list-tile>
                </v-card-actions>
              </v-card>
            </template>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import SkeletonLoader from '@/components/skeleton/SkeletonLoader.vue';
import api from '@/modules/bcube-assistant/api';
import { copyToClipboard } from '@/utils';
import { mapGetters } from 'vuex';

export default {
  name: 'bbnx-bcube-assistant-social-network-summary',
  components: {
    SkeletonLoader,
  },
  props: {
    inputName: String,
    parentEditor: Object,
  },
  data() {
    return {
      loading: false,
      summary: null,
      profileSelected: 0,
    };
  },
  computed: {
    ...mapGetters(['bcubeAssistant']),
    currentTitle() {
      const state = this.parentEditor.state;
      return state.channels[state.currentChannel].draft.title;
    },
    currentSubtitle() {
      const state = this.parentEditor.state;
      return state.channels[state.currentChannel].draft.subtitles;
    },
    currentBody() {
      const state = this.parentEditor.state;
      return state.channels[state.currentChannel].draft.body;
    },
    currentMainCategory() {
      const state = this.parentEditor.state;
      return state.channels[state.currentChannel].draft.mainTaxonomyId.name;
    },
    profileSelectorItems() {
      return this.bcubeAssistant.socialNetworkSummarySuggestion.map((title, i) => ({
        text: title,
        value: i,
      }));
    },
  },
  methods: {
    async copySummaryInClipboard() {
      await copyToClipboard(this.summary);
      this.toast.notify('message.list.actions.clipboardCopy');
    },
    closeWizard() {
      this.$emit('dismiss');
    },
    async loadSummary() {
      this.loading = true;
      this.summary = null;

      try {
        const profile = this.bcubeAssistant.socialNetworkSummarySuggestion[this.profileSelected] || '';

        const result = await api.socialNetworkSummary(profile, this.currentTitle, this.currentSubtitle, this.currentBody, this.currentMainCategory);
        this.summary = result.summary;
      } catch (e) {
        this.summary = null;
        console.error(e);

        if (!e.response) {
          e.response = {};
        }
        switch (e.response.status) {
          case 412:
            this.toast.notify('message.error.bcubeAssistant.tokenLimitReached');
            break;
          default:
            this.toast.notify('message.error.serverError');
            break;
        }
      } finally {
        this.loading = false;
      }
    },
    async updateTitle(title) {
      await this.parentEditor.$refs.form.updateField(this.inputName, title);
      let history = await this.parentEditor.$refs.form.draft.bcubeAssistantHistory;
      if (history === null || history === undefined) {
        history = [];
      }
      history[this.inputName] = await this.parentEditor.$refs.form.draft[this.inputName];
      await this.parentEditor.$refs.form.updateField('bcubeAssistantHistory', history);
      this.closeWizard();
    },
  },
  mounted() {
    if (!this.summary) {
      this.loadSummary();
    }
  },
};
</script>
